module.exports = __webpack_public_path__ + "static/media/xiaolaba.d1fc17e5.png";